import { TESTIMONIALS } from "@/lib/site";
import { Quote } from "lucide-react";

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="bg-bone py-20 md:py-32">
      <div className="px-5 sm:px-6 md:px-12 lg:px-16">
        <div className="max-w-3xl">
          <div className="text-[11px] sm:text-xs font-bold uppercase tracking-[0.25em] sm:tracking-[0.3em] text-sunrise">— Word on the job site</div>
          <h2 className="mt-4 font-display font-black text-navy tracking-tight text-[32px] sm:text-5xl lg:text-6xl leading-[1.04]">
            Trusted by homeowners <br />and businesses across Utah.
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-white border border-border p-8 lg:p-10 flex flex-col justify-between min-h-[320px] rounded-2xl elev-1 hover:elev-2 transition-shadow"
            >
              <Quote className="w-8 h-8 text-sunrise" />
              <blockquote className="mt-6 text-navy text-lg leading-relaxed font-medium">&ldquo;{t.quote}&rdquo;</blockquote>
              <figcaption className="mt-8 pt-6 border-t border-border">
                <div className="font-display font-bold text-navy">{t.name}</div>
                <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground mt-1">{t.role}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
